const s = {
  name: "CurrencyCzechKoruna",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23.9,21.9c0.6-0.5,1.3-0.9,2.1-0.9c0.8,0,1.6,0.3,2.1,0.9l1.4-1.4C28.6,19.6,27.4,19,26,19
			c-1.4,0-2.6,0.6-3.5,1.5l0,0C21.6,21.4,21,22.6,21,24c0,2.8,2.2,5,5,5c1.4,0,2.6-0.6,3.5-1.5l-1.4-1.4C27.6,26.7,26.8,27,26,27
			c-1.7,0-3-1.3-3-3C23,23.2,23.3,22.4,23.9,21.9z"/>
		<path class="st0" d="M23.7,12.3l-1.4,1.4l3.7,3.7l3.7-3.7l-1.4-1.4L26,14.6L23.7,12.3z"/>
		<path class="st0" d="M9,11h2v8.7l5.6-8.7H19l-5.8,9l5.8,9h-2.4L12,21.8l-1,1.5V29H9V11z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CurrencyCzechKoruna
};
